define('searchExpander',['jquery'],
    function ($) {

        var globalSearchInput = $(".search-list input");
        globalSearchInput.blur();

        $('.search').on('click', function (e) {

            var $inputField = $('.global-search');
            var value = $inputField.val();
            var placeholderValue = $inputField.attr('placeholder');
            e.preventDefault();
            var $this = $(this);

            if ($inputField.hasClass('closed-box')) {
                $inputField.removeClass('closed-box').addClass('open-box');
                $inputField.focus();
            }
            else {
                if ($inputField.val() === '' || placeholderValue == value) {
                    $inputField.removeClass('open-box').addClass('closed-box');
                }
                else {
                    //get the first form on the page. instead of signup form
                    $(".root-form").submit();
                }
            }
        });
        $('.close-search').on('click', function (e) {

            var $inputField = $('.global-search');
            e.preventDefault();

            if ($inputField.hasClass('open-box')) {
                $inputField.removeClass('open-box').addClass('closed-box');
            }
           
        });
        
    });

